// Confirma el pago al regresar de Stripe (POST /payments/confirm), sin
// esperar al webhook. El backend consulta la sesión directo a Stripe, así que
// esto no se puede falsificar desde el navegador.
import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL, getAuthHeader } from '../services/api';

const RETRIES = 3;
const RETRY_DELAY_MS = 2000;

// 'checking' -> consultando | 'paid' -> pagado | 'processing' -> Stripe aún no
// lo marca como pagado (el webhook lo hará después) | 'unknown' -> sin session_id
export const usePaymentConfirmation = (sessionId) => {
  const [status, setStatus] = useState(sessionId ? 'checking' : 'unknown');

  useEffect(() => {
    if (!sessionId) return undefined;
    let active = true;
    let timer;

    const attempt = async (n) => {
      try {
        const res = await axios.post(`${API_BASE_URL}/payments/confirm`, { sessionId }, { headers: getAuthHeader() });
        if (!active) return;
        if (res.data.paid) setStatus('paid');
        else if (n < RETRIES) timer = setTimeout(() => attempt(n + 1), RETRY_DELAY_MS);
        else setStatus('processing');
      } catch {
        // Sin sesión iniciada, red caída, etc. - el webhook sigue siendo el respaldo
        if (active) setStatus('processing');
      }
    };
    attempt(0);

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [sessionId]);

  return status;
};
